import styled, { css } from 'styled-components'

const contentStyles = props => {
  switch (props.size) {
    case 'small':
      return css`
        padding-left: 17px;
      `
    case 'regular':
      return css`
        padding-left: 24px;
      `
    case 'large':
      return css`
        padding-left: 33px;
      `
    case 'x-large':
      return css`
        padding-left: 44px;
      `
    default:
      return null
  }
}
export const Content = styled.div`
  font-family: 'nzk' !important;
  ${contentStyles};
`

const iconContainerStyles = props => {
  switch (props.size) {
    case 'small':
      return css`
        left: 7px;
      `
    case 'regular':
      return css`
        left: 11px;
      `
    case 'large':
      return css`
        left: 14px;
      `
    case 'x-large':
      return css`
        left: 22px;
      `
    default:
      return null
  }
}

export const IconContainer = styled.div`
  position: absolute;
  ${iconContainerStyles};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
